const userAgent = navigator.userAgent.toLowerCase();

const checkNavigator = (types) => {
  return (types || []).some((x) => {
    return userAgent.indexOf(x) !== -1;
  });
};

globalThis.browserInfo = {
  safari: checkNavigator(['safari']) && !checkNavigator(['chrome']),
  iphone: checkNavigator(['iphone']),
  ipad: checkNavigator(['ipad']),
  chrome: checkNavigator(['chrome']),
  firefox: checkNavigator(['firefox']),
  edge: checkNavigator(['edge/']) || checkNavigator(['edg/'])
};

// iPadOS 13+ identifies as Mac, so we need to check for touch support to detect if the device is an iPad
const modernIpadCheck = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

// Unsupported browser handling
const supportedBrowser =
  (browserInfo.chrome ||
    browserInfo.iphone ||
    browserInfo.ipad ||
    modernIpadCheck ||
    (browserInfo.safari && window.location.href.includes('/mobile'))) &&
  !browserInfo.edge;

if (browserInfo.edge) {
  // If current browser is Edge and the user has not previously seen the Edge warning
  if (!sessionStorage.getItem(`browserCheck`)) {
    // Set a session storage flag to prevent the Edge warning from showing again
    sessionStorage.setItem(`browserCheck`, 'true');

    document.body.innerHTML = '';
    document.body.style.backgroundColor = '#003e51';
    document.body.style.color = 'white';
    document.body.style.height = '100%';
    document.body.style.width = '100%';
    document.body.style.position = 'absolute';
    document.body.style.margin = '0';
    document.body.style.display = 'flex';
    document.body.style.flexDirection = 'column';
    document.body.style.alignItems = 'center';
    document.body.style.justifyContent = 'center';
    document.body.style.fontFamily = 'Roboto';
    document.body.innerHTML =
      '<p style="margin: 100px; font-size: 12vmin; font-weight: bold; text-align: center;">Unsupported Browser</p><p style="margin: 48px; margin-top: -24px; font-size: 5vmin; text-align: center">Edge is not a supported browser for Katapult Pro. If you encounter any issues, please try Google Chrome.</p><a style="text-decoration: none;" onclick="function continueToKatapult() {location.reload()} continueToKatapult()"><div style="background-color: #007299; color: white; padding: 0.7em 0.57em; border-radius: 999px; cursor: pointer;">CONTINUE TO KATAPULT PRO</div></a>';
  }
} else if (!supportedBrowser && !navigator.standalone) {
  // If the current browser is not Edge and the browser is not supported
  document.body.innerHTML = '';
  document.body.style.backgroundColor = '#003e51';
  document.body.style.color = 'white';
  document.body.style.height = '100%';
  document.body.style.width = '100%';
  document.body.style.position = 'absolute';
  document.body.style.margin = '0';
  document.body.style.display = 'flex';
  document.body.style.flexDirection = 'column';
  document.body.style.alignItems = 'center';
  document.body.style.justifyContent = 'center';
  document.body.style.fontFamily = 'Roboto';
  document.body.innerHTML =
    '<p style="margin: 100px; font-size: 12vmin; font-weight: bold; text-align: center;">Unsupported Browser</p><p style="margin: 48px; margin-top: -24px; font-size: 5vmin;">Your browser is not supported</p><a style="text-decoration: none;" href="https://www.google.com/chrome"><div style="background-color: #007299; color: white; padding: 0.7em 0.57em; border-radius: 999px; cursor: pointer;">TRY GOOGLE CHROME INSTEAD</div></a>';
} else if ((browserInfo.ipad || modernIpadCheck) && (window.location.href.includes('/map') || window.location.href.includes('/photos'))) {
  // If current device is an iPad and the user has not previously chosen to continue to Katapult Pro Desktop in this session
  if (!sessionStorage.getItem(`ipadCheck`)) {
    document.body.innerHTML = '';
    document.body.style.backgroundColor = '#003e51';
    document.body.style.color = 'white';
    document.body.style.height = '100%';
    document.body.style.width = '100%';
    document.body.style.position = 'absolute';
    document.body.style.margin = '0';
    document.body.style.display = 'flex';
    document.body.style.flexDirection = 'column';
    document.body.style.alignItems = 'center';
    document.body.style.justifyContent = 'center';
    document.body.style.fontFamily = 'Roboto';
    document.body.innerHTML =
      '<p style="margin: 100px; font-size: 12vmin; font-weight: bold; text-align: center;">Unsupported Device</p><p style="margin: 48px; margin-top: -24px; font-size: 5vmin; text-align: center">Katapult Pro Desktop is not supported on mobile devices. If you encounter any issues, please use the mobile version.</p><a style="text-decoration: none;" onclick="window.location.href = window.location.href.replace(`/map`, `/mobile`).replace(`/photos`, `/mobile`)"><div style="background-color: #007299; color: white; margin: 1em; padding: 0.7em 0.57em; border-radius: 999px; cursor: pointer;">USE MOBILE (RECOMMENDED)</div></a><a style="text-decoration: none;" onclick="function continueToKatapult() {sessionStorage.setItem(`ipadCheck`, `true`); location.reload();} continueToKatapult()"><div style="background-color: #e17e03; color: white; padding: 0.7em 0.57em; border-radius: 999px; cursor: pointer;">CONTINUE TO KATAPULT PRO DESKTOP</div></a>';
  }
}
